import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import styles from "./Imprint.module.scss";

const Imprint = () => {
    return (
        <Layout title="Imprint - Desi Fresh">
            <div className={`${styles.imprint_wrapper} container`}>
                {window.innerWidth < 991 ? (
                    <BreadCrumb
                        list={[
                            { name: "Home", link: "/" },
                            { name: "Service", link: "/imprint" },
                            { name: "Imprint", link: "/imprint" },
                        ]}
                    />
                ) : (
                    <BreadCrumb
                        list={[
                            { name: "Back to Home", link: "/" },
                            { name: "Service", link: "/imprint" },
                            { name: "Imprint", link: "/imprint" },
                        ]}
                    />
                )}

                <h2 className={styles.title}>Imprint</h2>

                <div className={styles.imprint_content_wrap}>
                    <div className={styles.contact_cs}>
                        <p>Contact customer service:</p>
                        <p>Telephone: 8161 / 519 3562</p>
                        <p>
                            Email:{" "}
                            <a href="mailto:customers@desifresh.co">
                                customers@desifresh.co
                            </a>{" "}
                        </p>
                    </div>

                    <div className={styles.questions_info}>
                        <p>Questions about online orders:</p>
                        <p>Email: orders@desifresh.co</p>
                    </div>
                    <div className={styles.questions_info}>
                        <p>Questions about our products: </p>
                        <p>quality@desifresh.co</p>
                    </div>
                    <div className={styles.questions_info}>
                        <p>Questions about the application:</p>
                        <p>career@desifresh.co</p>
                    </div>
                    <div className={styles.questions_info}>
                        <p>According to § 5 TMG:</p>
                        <p>
                            Responsible for the website and our appearances on
                            YouTube, Facebook, Twitter, Instagram, & Linkedin
                        </p>
                    </div>
                    <div className={styles.questions_info}>
                        <p>Desi Fresh</p>
                        <p>
                            Königsteinstraße 1/3, 80807 München <br />
                            Phone: 8161/ 519-3562 <br />
                            Fax: 8161/519-3563 <br />
                            Email: info@desifresh.co
                        </p>
                    </div>
                    <div className={styles.questions_info}>
                        <p>Desi Fresh</p>
                        <p>
                            Sonnenstraße 7a, 85764 Oberschleißheim <br />
                            Phone: 8161/ 519-3562 <br />
                            Fax: 8161/519-3563 <br />
                            Email: info@desifresh.co
                        </p>
                    </div>
                    <div className={styles.questions_info}>
                        <p>Managing Director:</p>
                        <p>Dr. Preeti Wani</p>
                    </div>
                    <div className={styles.questions_info}>
                        <p>Registered Place, Registration Court:</p>
                        <p>Freising, HRB 171 865 Amtsgericht München </p>
                    </div>
                    <div className={styles.questions_info}>
                        <p>VAT identification number:</p>
                        <p>DE 289327825</p>
                    </div>
                    <div className={styles.questions_info}>
                        <p>Responsible according to § 18 Abs. 2 MStV:</p>
                        <p>
                            Dr. Ali Abas Wani, Königsteinstraße 1/3, 80807
                            München, Bayern
                        </p>
                    </div>
                    <div className={styles.questions_info}>
                        <p>Dispute Resolution Notice</p>
                        <p>
                            According to applicable law, we are obliged to
                            inform our customers of the existence of the
                            European online dispute resolution platform:
                        </p>
                        <a
                            href="http://ec.europa.eu/odr"
                            className={styles.eu_link}
                        >
                            http://ec.europa.eu/odr
                        </a>
                    </div>
                    <div className={styles.contact_mail}>
                        Contact:{" "}
                        <a href="mailto:customers@ desifresh.co">
                            customers@ desifresh.co
                        </a>{" "}
                    </div>

                    <p style={{ marginBottom: 8 }}>
                        Desi Fresh does not take part in dispute settlement
                        procedures of a consumer arbitration board and is not
                        obliged to do so.
                    </p>

                    <div className={styles.links}>
                        <Link to={"/"}>Contact</Link>
                        <Link to={"/faq"}>FAQ</Link>
                        <Link to={"/"}>Data protection</Link>
                    </div>

                    <div className={styles.questions_info}>
                        <p>Photo credits:</p>
                        <ul className={styles.cred}>
                            <li>freepic.com</li>
                        </ul>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Imprint;
